import SEOContent from './SEOContent';

export default SEOContent;
